import clsx from "clsx";
import { Box, Button, CircularProgress, Switch } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import useEnableOCRForm from "./useEnableOCRForm";

function EnableOCRForm() {
  const { classes, checked, toggleChecked, isLoading, submit } =
    useEnableOCRForm();

  return (
    <Box paddingLeft={"2rem"}>
      <form onSubmit={submit}>
        <Box className={classes.title}>
          <FormattedMessage id="enableOCR" />*
          <Box paddingTop={"2rem"} paddingLeft={"1rem"}>
            <Switch
              size="medium"
              checked={checked}
              color="primary"
              onChange={toggleChecked}
            />
            <FormattedMessage id={`${checked ? "enabled" : "disabled"}`} />
          </Box>
        </Box>
        <Box mt={5} display="flex" justifyContent={"center"}>
          <Button
            className={clsx(classes.btn, classes.save)}
            autoFocus
            type={"submit"}
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress className={classes.btnLoading} />
            ) : (
              <FormattedMessage id="Save" />
            )}
          </Button>
        </Box>
      </form>
    </Box>
  );
}

export default EnableOCRForm;
